// *******************************
// * THIS IS AUTO GENERATED FILE *
// *******************************

// TracksOffice.Models.Login.AnswerSecretPackContract
export interface AnswerSecretPackContract {
	username: string;
	answers: AnswerSecretContract[];
}
// TracksOffice.Models.Login.AnswerSecretContract
export interface AnswerSecretContract {
	questionId: string;
	answer: string;
}
// TracksOffice.Models.Login.ResetPasswordContract
export interface ResetPasswordContract {
	username: string;
	password: string;
	confirm: string;
	answers: AnswerSecretContract[];
}
// TracksOffice.Models.Login.ResetExpiredPasswordContract
export interface ResetExpiredPasswordContract {
	username: string;
	oldPassword: string;
	newPassword: string;
	confirmPassword: string;
}
// TracksOffice.Models.Login.ChangePasswordIsForsedContract
export interface ChangePasswordIsForsedContract {
	isNeedToChangePwd: boolean;
}

// TracksOffice.Models.Login.QuestionModelResponse
export interface QuestionModelResponse_Server {
	QuestionId: string;
	QuestionText: string;
}
// TracksOffice.Models.Login.QuestionModelResponse
export interface QuestionModelResponse {
	questionId: string;
	questionText: string;
}

// Convert QuestionModelResponse_Contract > QuestionModelResponse_Response
export const map_QuestionModelResponse = (data: QuestionModelResponse_Server): QuestionModelResponse => {
	return {
		questionId: data.QuestionId,
		questionText: data.QuestionText,
	};
};
